import {accessTokenKey, logoutEventKey} from 'features/common/core/constants'

export const getUserToken = () => sessionStorage.getItem(accessTokenKey)
export const setUserToken = (token: string) =>
    sessionStorage.setItem(accessTokenKey, token)
export const clearUserToken = () => sessionStorage.removeItem(accessTokenKey)

export const logoutOnUnauthorized = () => {
    clearUserToken()
    window.dispatchEvent(new Event(logoutEventKey))
}
